import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetSliderFailed, EGetSliderActionType } from './types';
import { ISliderNameAndAudienceType } from '../../../types/slider';

export const getSliderFailed: (data: ISliderNameAndAudienceType) => TGetSliderFailed = actionGenerator<
  EGetSliderActionType.Failed,
  ISliderNameAndAudienceType
>(EGetSliderActionType.Failed);
